import { z } from 'zod';

export const SystemRoleZod = z.union([z.literal('user'), z.literal('advisor'), z.literal('admin')]);

export type SystemRole = z.infer<typeof SystemRoleZod>;
